import { CUSTOM_DOMAIN_LIST } from '../constants/config';

export const isCustomDomain = hostname =>
  CUSTOM_DOMAIN_LIST.some(domain => hostname.endsWith(domain));

export const getApiOrigin = (location = window.location) => {
  const { hostname, protocol } = location;

  if (isCustomDomain(hostname)) {
    return `${protocol}//apis.${hostname}/${process.env.REACT_APP_FMP_APIS_URL_BASE_PATH}`;
  }
  return process.env.REACT_APP_FMP_APIS_URL;
};

// Get the chat service URL based on environment
export const getChatBaseUrl = () => {
  // For local development, use the chat service port
  if (process.env.REACT_APP_CHATBOT_URL) {
    return process.env.REACT_APP_CHATBOT_URL;
  }

  // For deployed environments, use the FMP APIs base URL without /v1
  const apisBase = getApiOrigin();
  return apisBase.replace('/v1', '');
};
